import { useSelector } from 'react-redux';
import MainLayout from '../layouts/main';
import CardsContainer from './container';

function CardPage() {
  const { isSuperuser } = useSelector(({ user }) => user.data);
  return <MainLayout withFooter>{isSuperuser ? <CardsContainer /> : null}</MainLayout>;
}

export default CardPage;
